import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import resourcesToBackend from "i18next-resources-to-backend";
import { USER_STORAGE_KEYS } from "./constants/storage";

function getLineupUserLanguage() {
  try {
    const userStr = localStorage.getItem(USER_STORAGE_KEYS.AUTH_SESSION);
    if (userStr) {
      const user = JSON.parse(userStr);
      if (user.language) return user.language;
    }
  } catch (e) {}
  return null;
}

i18n
  .use(resourcesToBackend((language, namespace) => 
    import(`./locales/${language}/${namespace}.json`)
  ))
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    fallbackLng: "en",
    supportedLngs: ["de", "en", "fr", "zh"],
    
    // Standard-Namespace, falls keiner angegeben wird
    defaultNS: 'common',
    fallbackNS: 'common',

    // NUR die Namespaces, die vor dem ersten Render dastehen müssen.
    // `ns` ist keine Registrierung, sondern eine Vorladeliste: i18next reicht sie
    // beim Init unverändert an den Backend-Connector weiter (i18next.js,
    // `loadResources`), und zwar für jede Sprache der Auflösungskette. Standen hier
    // alle 37 Namespaces, holte jeder Seitenaufruf 37 × 2 Dateien (aktive Sprache +
    // `fallbackLng`), rund 1,2 MB.
    //
    // Alles andere lädt `useTranslation([...])` bei Bedarf nach und hält den Render
    // so lange an — die Suspense-Grenzen dafür stehen in layouts/Vertical.js und
    // routes/Routes.js. Diese vier gehören hierher, weil sie NICHT nachgeladen werden:
    //   common      defaultNS + fallbackNS, wird bei jeder Auflösung gebraucht
    //   layouts     Menü, Topbar, Footer — der Rahmen um alles
    //   components  NotificationDropdown, ProfileDropdown, TopbarSearch, TourDropdown
    //   helpers     paymentConditions.js greift per getFixedT() zu, also außerhalb
    //               von React: das löst kein Nachladen aus und lieferte sonst den
    //               rohen Schlüssel.
    ns: ['common', 'components', 'layouts', 'helpers'],

    keySeparator: ">>", // Erlaubt Texte mit Punkten (.) als Keys
    nsSeparator: '::',   // Ermöglicht Namespace-Trennung (z.B. account::title)
    
    interpolation: {
      escapeValue: false, // React schützt bereits vor XSS
    },

    react: {
      // useTranslation(["tasks", "components", "common"]) soll ALLE genannten
      // Namensräume durchsuchen, nicht nur den ersten. Ohne das bindet react-i18next
      // das t() allein an den ERSTEN Eintrag (`namespaces[0]`, useTranslation.js) und
      // fällt danach nur noch auf `fallbackNS: "common"` — jeder Schlüssel, der nur in
      // components.json steht, kam als roher Schlüssel zurück. Bei englischen
      // Schlüsseln fällt das nicht auf (der Schlüssel IST der englische Text), bei den
      // deutschen Anrufergebnis-Etiketten aus callOutcomes.json schon: die standen
      // auf der englischen Oberfläche auf Deutsch.
      nsMode: "fallback",
    },

    lng: getLineupUserLanguage() || undefined,
  });

export default i18n;
